import { render, staticRenderFns } from "./Nature.vue?vue&type=template&id=2967d8cc&scoped=true"
import script from "./Nature.vue?vue&type=script&lang=js"
export * from "./Nature.vue?vue&type=script&lang=js"
import style0 from "./Nature.vue?vue&type=style&index=0&id=2967d8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2967d8cc",
  null
  
)

export default component.exports